import React from 'react';
import Reveal from './Reveal';
import { CITIES, EMAIL, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { track, EVENTS } from '../utils/analytics';

interface CtaBlockProps {
  title?: string;
  lede?: string;
  where: string;
}

const CtaBlock: React.FC<CtaBlockProps> = ({
  title = 'Tell us what your team still does by hand.',
  lede = 'We’ll tell you what can be automated, what shouldn’t be, and what it would take.',
  where,
}) => (
  <section className="cta" id="contact">
    <div className="shell cta__inner">
      <Reveal>
        <h2 className="h2">{title}</h2>
      </Reveal>
      <Reveal index={1}>
        <p className="lead">{lede}</p>
      </Reveal>
      <Reveal index={2}>
        <div className="cta__lines">
          <a
            href={`mailto:${EMAIL}`}
            onClick={() => track(EVENTS.emailClicked, { location: where })}
          >
            {EMAIL}
          </a>
          <a
            href={`tel:${PHONE_HREF}`}
            onClick={() => track(EVENTS.phoneClicked, { location: where })}
          >
            {PHONE_DISPLAY}
          </a>
        </div>
        <p className="cta__where">{CITIES}</p>
      </Reveal>
    </div>
  </section>
);

export default React.memo(CtaBlock);
